import { CONFUSION_DIALOG_TYPE_ENUM, CONFUSION_PROPAGATION_TYPE_ENUM } from '../enum/ConfusionEnum';
import {
    ConfusionDialogContent,
    ConfusionDialogSettings,
    ConfusionModel,
    ConfusionReaction,
    ConfusionPropagation,
    Confusion,
    Tracking,
    TrackingSecurity,
} from '../typings/Tracking';

export const CONFUSION_DIALOG_CONTENT_DEFAULT: ConfusionDialogContent = {
    label: {
        en: 'Do you need a help?',
        sk: 'Potrebujete pômocť?',
    },
    cancelText: {
        en: 'No',
        sk: 'Nie',
    },
    confirmText: {
        en: 'Yes',
        sk: 'Áno',
    },
};

export const CONFUSION_DIALOG_DEFAULT: ConfusionDialogSettings = {
    enabled: false,
    type: CONFUSION_DIALOG_TYPE_ENUM.DETECTION_BASED,
    content: CONFUSION_DIALOG_CONTENT_DEFAULT,
};

export const CONFUSION_MODEL_DEFAULT: ConfusionModel = {
    enabled: false,
    type: 'detection',
    id: 'default',
    confusionTimeoutSeconds: 100,
    urls: [],
};

export const CONFUSION_REACTION_DEFAULT: ConfusionReaction = {
    type: 'shakeContextHelp',
    numberOfShakes: 3,
};

export const CONFUSION_PROPAGATION_DEFAULT: ConfusionPropagation = {
    type: CONFUSION_PROPAGATION_TYPE_ENUM.GUIDE_INTERACTION_PROPAGATION,
    timeout: 5000,
};

export const CONFUSION_DEFAULT: Confusion = {
    reaction: CONFUSION_REACTION_DEFAULT,
    propagation: CONFUSION_PROPAGATION_DEFAULT,
};

export const TRACKING_SECURITY_DEFAULT: TrackingSecurity = {
    hashUserId: false,
};

export const TRACKING_DEFAULT: Tracking = {
    enabled: false,
    batchInterval: 1000,
    sampleRate: 16,
    expert: false,
    events: {
        click: false,
        keydown: false,
        keyup: false,
        mousedown: false,
        mousemove: false,
        mouseup: false,
        scroll: false,
    },
    schedule: '',
    confusionDialog: CONFUSION_DIALOG_DEFAULT,
    model: CONFUSION_MODEL_DEFAULT,
    confusion: CONFUSION_DEFAULT,
    whitelist: { patterns: [] },
    collectionExtensions: [],
    security: TRACKING_SECURITY_DEFAULT,
};
